export const FILTERED_PHRASES = {
  en: [
    " www.mooji.org",
    "thanks for watching",
    "thank you for watching",
    "thank you very much",
    "thank you for your watching",
    "see you in the next video",
    "see you next video",
    "see you next time",
    "i'll see you next time",
    "bye, ladies and gentlemen",
    "bye",
    "thank you. bye bye",
    "thanks mate",
    "hello everyone welcome to my channel",
    "hello and welcome to another episode of the",
    "i'm not sure what i'm doing here",
    "i'm not sure what to do with this",
    "i'm not sure why i'm doing this",
    "i'm not sure if i can do this",
    "we'll be right back",
    "subtitles by the amara org community",
    "subtitles by steamteamextra",
    "closed captioning provided by the imperial news network",
    "closed captioning provided by muhsen",
    "transcript emily beynon"
  ],
  es: [
    " Subtítulos realizados por la comunidad de Amara.org",
    "Subtitulado por la comunidad de Amara.org",
    "Subtítulos por la comunidad de Amara.org",
    "Subtítulos creados por la comunidad de Amara.org",
    "Subtítulos en español de Amara.org",
    "Subtítulos hechos por la comunidad de Amara.org",
    "Subtitulos por la comunidad de Amara.org",
    "la comunidad de",
    " Más información www.alimmenta.com",
    " www.mooji.org",
    "Subtítulos realizados por",
    "Subtitulos realizados por",
    "Transcripción realizada por",
    "Transcripcion realizada por",
    "amara.org",
    "Amara.org",
    "¡Gracias por ver el vídeo!",
    "Gracias por ver el video",
    "¡Suscríbete para más!",
    "Suscríbete para más",
    "Suscríbete y dale a like"
  ],
  de: [
    " Untertitelung aufgrund der Amara.org-Community",
    " Untertitel im Auftrag des ZDF für funk, 2017",
    " Untertitel von Stephanie Geiges",
    " Untertitel der Amara.org-Community",
    " Untertitel im Auftrag des ZDF, 2017",
    " Untertitel im Auftrag des ZDF, 2020",
    " Untertitel im Auftrag des ZDF, 2018",
    " Untertitel im Auftrag des ZDF, 2021",
    " Untertitelung im Auftrag des ZDF, 2021",
    " Copyright WDR 2021",
    " Copyright WDR 2020",
    " Copyright WDR 2019",
    " SWR 2021",
    " SWR 2020",
    "Danke fürs Zuschauen!"
  ],
  fr: [
    " Sous-titres réalisés para la communauté d'Amara.org",
    " Sous-titres réalisés par la communauté d'Amara.org",
    " Sous-titres fait par Sous-titres par Amara.org",
    " Sous-titres réalisés par les SousTitres d'Amara.org",
    " Sous-titres par Amara.org",
    " Sous-titres par la communauté d'Amara.org",
    " Sous-titres réalisés pour la communauté d'Amara.org",
    " Sous-titres réalisés par la communauté de l'Amara.org",
    " Sous-Titres faits par la communauté d'Amara.org",
    " Sous-titres par l'Amara.org",
    " Sous-titres fait par la comunidad d'Amara.org",
    " Sous-titrage ST' 501",
    " Sous-titrage ST'501",
    " Cliquez-vous sur les sous-titres et abonnez-vous à la chaîne d'Amara.org",
    " ❤️ par SousTitreur.com",
    "Merci d'avoir regardé cette vidéo.",
    "Merci d'avoir regardé cette vidéo!",
    "Merci d'avoir regardé la vidéo.",
    "Merci d'avoir regardé!",
    "J'espère que vous avez apprécié la vidéo.",
    "Je vous remercie de vous abonner"
  ],
  nl: [
    " Ondertitels ingediend door de Amara.org gemeenschap",
    " Ondertiteld door de Amara.org gemeenschap",
    " Ondertiteling door de Amara.org gemeenschap"
  ],
  it: [
    " Sottotitoli creati dalla comunità Amara.org",
    " Sottotitoli di Sottotitoli di Amara.org",
    " Sottotitoli e revisione al canale de Amara.org",
    " Sottotitoli e revisione a cura de Amara.org",
    " Sottotitoli e revisione a cura di QTSS",
    " Sottotitoli e revisione a cura di QTSS.",
    " Sottotitoli a cura de QTSS"
  ],
  gl: [
    " Subtítulos realizados por la comunidad de Amara.org"
  ],
  pt: [
    " Legendas pela comunidade Amara.org",
    " Legendas pela comunidade de Amara.org",
    " Legendas pela comunidade do Amara.org",
    " Legendas pela comunidade das Amara.org",
    " Transcrição e Legendas pela comunidade de Amara.org",
    "e se inscreva no canal",
    "Tchau, galera!",
    "Tchau tchau!",
    "Valeu.",
    "Tchau!",
    "Obrigado.",
    "E aí",
    "Oi!"
  ],
  la: [
    " Sottotitoli creati dalla comunità Amara.org",
    " Sous-titres réalisés para la comunidad d'Amara.org"
  ],
  ln: [
    " Sous-titres realizados para la comunidad d'Amara.org"
  ],
  pl: [
    " Napisy stworzone przez społeczność Amara.org",
    " Napisy wykonane przez społeczność Amara.org",
    " Zdjęcia i napisy stworzone przez społeczność Amara.org",
    " napisy stworzone przez społeczność Amara.org",
    " Tłumaczenie i napisy stworzone przez społeczność Amara.org",
    " Napisy stworzone przez społeczności Amara.org",
    " Tłumaczenie stworzone przez społeczność Amara.org",
    " Napisy robione przez społeczność Amara.org",
    " www.multi-moto.eu"
  ],
  ru: [
    " Редактор субтитров А.Синецкая Корректор А.Егорова"
  ],
  tr: [
    " Yorumlarınızıza abone olmayı unutmayın."
  ],
  su: [
    " Sottotitoli creati dalla comunità Amara.org"
  ],
  zh: [
    "字幕由Amara.org社区提供",
    "小編字幕由Amara.org社區提供"
  ]
} as const;

export const ALL_FILTERED_PHRASES = Object.values(FILTERED_PHRASES).flat();

export const NO_SPEECH_MESSAGE = "No se ha detectado nadie hablando en el audio";
